<script>
export default {
  computed: {
    isFromEvollu: function () {
      return this.$auth.user().entity.id === 1
    },
    isDevUser: function () {
      return this.$auth.user().id === 1
    }
  },
  methods: {
    userIsFromEntity: function (entityId) {
      return this.$auth.user().entity.id === entityId
    }
  }
}
</script>
